module.exports = __webpack_public_path__ + "static/img/bg4.13b01ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg4.jpg
// module id = BSGj
// module chunks = 0